import React from "react";

function Spinner() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-[2px] bg-white/70">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-16 h-16 border-4 border-t-transparent border-black rounded-full animate-spin"></div>
        <p className="text-lg font-semibold text-black animate-pulse">
          Please wait, generating your file...
        </p>
        <span className="animate-bounce text-2xl">📊</span>
      </div>
    </div>
  );
}

export default Spinner;
